// extracted by mini-css-extract-plugin
module.exports = {"fullscreenLoadingContainer":"FullscreenLoading_fullscreenLoadingContainer__2cXN9","fullscreenLoadingSpinnerContainer":"FullscreenLoading_fullscreenLoadingSpinnerContainer__2pOmZ"};